import {isEmpty} from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types'
import contactIcon from './contact.svg';

/**
 * The TicketViewContact component.
 *
 * @constructor
 */
export class TicketViewContact extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const contact = this.props.contact || {};

    return (
      <div className="ticket-view-contact">
        <div className="media-object">
          <div className="media-object-section icon-wrapper">
            <img className="icon" src={contactIcon} alt="contact information"/>
          </div>
          <div className="media-object-section">
            <div className="schedule-data">
              <h3>Contact Information</h3>

              {(contact.name) && (
                <div>Name: {contact.name}</div>
              )}

              {(contact.phone) && (
                <div>Phone: {contact.phone}</div>
              )}

              {(contact.email) && (
                <div>E-Mail: {contact.email}</div>
              )}

              {(isEmpty(contact)) && (
                <div>No contact information provided</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TicketViewContact.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string
  }).isRequired
};

export default TicketViewContact;



// WEBPACK FOOTER //
// ./src/components/ticket/ticketViewContact/TicketViewContact.js